/**
 * Contains data for all the lines.
 *
 * @typedef {Object} LineInfo
 * @property {string} name — Display name of the line.
 * @property {string[]} designers — List of designer names.
 * @property {string} video_ready — URL to the pre-show teaser video.
 * @property {string} description — Long-form marketing description.
 * @property {string|null} img_1 — Primary pre-show hero image URL.
 * @property {string|null} img_2 — Secondary pre-show hero image URL.
 * @property {string[][]} post_show_img — Grouped post-show image URLs.
 */

export const GITHUB_BASE_URL = 'https://github.com/lunar-gala/2021-eusociality-videos/raw/master/';

/*** PRE SHOW PHOTOS ***/
import GOSSAMERIDLE_1 from "../../assets/img/lines/GossamerIdle_1.jpg";
import GOSSAMERIDLE_2 from "../../assets/img/lines/GossamerIdle_2.jpg";
import NEXUS_1 from "../../assets/img/lines/Nexus_1.jpg";
import NEXUS_2 from "../../assets/img/lines/Nexus_2.jpg";
import CHRYSOPHYTA_1 from "../../assets/img/lines/Chrysophyta_1.jpg";
import CHRYSOPHYTA_2 from "../../assets/img/lines/Chrysophyta_2.jpg";
import MIRROR_1 from "../../assets/img/lines/Mirror_1.jpg";
import MIRROR_2 from "../../assets/img/lines/Mirror_2.jpg";
import MARIANASTRENCH_1 from "../../assets/img/lines/MarianasTrench_1.jpg";
import MARIANASTRENCH_2 from "../../assets/img/lines/MarianasTrench_2.jpg";
import OBFUSCATE_1 from "../../assets/img/lines/Obfuscate_1.jpg";
import OBFUSCATE_2 from "../../assets/img/lines/Obfuscate_2.jpg";
import SALVOS_1 from "../../assets/img/lines/Salvos_1.jpg";
import SALVOS_2 from "../../assets/img/lines/Salvos_2.jpg";
import BLOOM_1 from "../../assets/img/lines/Bloom_1.jpg";
import BLOOM_2 from "../../assets/img/lines/Bloom_2.jpg";
import RENSACI_1 from "../../assets/img/lines/Renasci_1.jpg";
import RENSACI_2 from "../../assets/img/lines/Renasci_2.jpg";
import BOUND_1 from "../../assets/img/lines/Bound_1.jpg";
import BOUND_2 from "../../assets/img/lines/Bound_2.jpg";
import INVASION_1 from "../../assets/img/lines/Invasion_1.jpg";
import INVASION_2 from "../../assets/img/lines/Invasion_2.jpg";
// import SOMATIC_1 from "../../assets/img/lines/Somatic_1.jpg";
// import SOMATIC_2 from "../../assets/img/lines/Somatic_2.jpg";
import RELINQUO_1 from "../../assets/img/lines/Relinquo_1.jpg";
import RELINQUO_2 from "../../assets/img/lines/Relinquo_2.jpg";
import DIGITALWARFARE_1 from "../../assets/img/lines/DigitalWarfare_1.jpg";
import DIGITALWARFARE_2 from "../../assets/img/lines/DigitalWarfare_2.jpg";
import ICARUS_1 from "../../assets/img/lines/Icarus_1.jpg";
import ICARUS_2 from "../../assets/img/lines/Icarus_2.jpg";
// import ALUM_1 from "../../assets/img/lines/Alum_1.jpg";
// import ALUM_2 from "../../assets/img/lines/Alum_2.jpg";

/*** POST SHOW PHOTOS ***/
import GOSSAMERIDLE_POST_11 from "../../assets/img/line_shoots/gossamer_idle/blue flowers (1).png";
import GOSSAMERIDLE_POST_21 from "../../assets/img/line_shoots/gossamer_idle/blue flowers (2).jpg";
import GOSSAMERIDLE_POST_12 from "../../assets/img/line_shoots/gossamer_idle/blue flowers (3).jpg";
import GOSSAMERIDLE_POST_22 from "../../assets/img/line_shoots/gossamer_idle/blue flowers (4).jpg";
import GOSSAMERIDLE_POST_31 from "../../assets/img/line_shoots/gossamer_idle/green dress (1).jpg";
import GOSSAMERIDLE_POST_32 from "../../assets/img/line_shoots/gossamer_idle/green dress (6).jpg";
import GOSSAMERIDLE_POST_41 from "../../assets/img/line_shoots/gossamer_idle/green dress (4).jpg";
import GOSSAMERIDLE_POST_42 from "../../assets/img/line_shoots/gossamer_idle/green dress (5).jpg";

import NEXUS_POST_11 from "../../assets/img/line_shoots/nexus/chains (1).jpg";
import NEXUS_POST_12 from "../../assets/img/line_shoots/nexus/chains (4).jpg";
import NEXUS_POST_21 from "../../assets/img/line_shoots/nexus/chains (2).jpg";
import NEXUS_POST_31 from "../../assets/img/line_shoots/nexus/IMG_3681.jpg";
import NEXUS_POST_32 from "../../assets/img/line_shoots/nexus/IMG_3690.jpg";
import NEXUS_POST_41 from "../../assets/img/line_shoots/nexus/PNTX7041.jpg";
import NEXUS_POST_42 from "../../assets/img/line_shoots/nexus/PNTX7049.jpg";

import CHRYSOPHYTA_POST_11 from "../../assets/img/line_shoots/chrysophyta/IMG_2225.jpg";
import CHRYSOPHYTA_POST_21 from "../../assets/img/line_shoots/chrysophyta/purple and teal.jpg";

import MIRROR_POST_11 from "../../assets/img/line_shoots/mirror/dress.jpg";
import MIRROR_POST_21 from "../../assets/img/line_shoots/mirror/vest.jpg";

import MARIANAS_TRENCH_POST_11 from "../../assets/img/line_shoots/marianas_trench/light purple (1).jpg";
import MARIANAS_TRENCH_POST_21 from "../../assets/img/line_shoots/marianas_trench/light purple (2).jpg";
// import MARIANAS_TRENCH_POST_31 from "../../assets/img/line_shoots/marianas_trench/light purple (3).jpg";
import MARIANAS_TRENCH_POST_41 from "../../assets/img/line_shoots/marianas_trench/IMG_2290.jpg";

import OBFUSCATE_POST_11 from "../../assets/img/line_shoots/obfuscate/IMG_3733.jpg";
import OBFUSCATE_POST_21 from "../../assets/img/line_shoots/obfuscate/IMG_3769.jpg";
import OBFUSCATE_POST_31 from "../../assets/img/line_shoots/obfuscate/PNTX7075.jpg";
import OBFUSCATE_POST_41 from "../../assets/img/line_shoots/obfuscate/PNTX7098.jpg";

import SALVOS_POST_11 from "../../assets/img/line_shoots/salvos/IMG_3124.jpg";
import SALVOS_POST_21 from "../../assets/img/line_shoots/salvos/PNTX6794.jpg";
import SALVOS_POST_31 from "../../assets/img/line_shoots/salvos/IMG_3157.jpg";
import SALVOS_POST_41 from "../../assets/img/line_shoots/salvos/dark blue and black.png";

import BLOOM_POST_11 from "../../assets/img/line_shoots/bloom/teal and white (1).jpg";
import BLOOM_POST_21 from "../../assets/img/line_shoots/bloom/teal and white (2).jpg";
import BLOOM_POST_31 from "../../assets/img/line_shoots/bloom/teal and white (3).jpg";
import BLOOM_POST_41 from "../../assets/img/line_shoots/bloom/all white.png";

import RENASCI_POST_11 from "../../assets/img/line_shoots/renasci/red gold roses (1).jpg";
import RENASCI_POST_12 from "../../assets/img/line_shoots/renasci/red gold roses (4).jpg";
import RENASCI_POST_21 from "../../assets/img/line_shoots/renasci/two piece (1).jpg";
import RENASCI_POST_31 from "../../assets/img/line_shoots/renasci/red gold roses (3).jpg";
import RENASCI_POST_32 from "../../assets/img/line_shoots/renasci/red gold roses (5).jpg";
import RENASCI_POST_41 from "../../assets/img/line_shoots/renasci/two piece (3).jpg";

import BOUND_POST_11 from "../../assets/img/line_shoots/bound/black dress (1).jpg";
import BOUND_POST_21 from "../../assets/img/line_shoots/bound/black top (1).jpg";
import BOUND_POST_31 from "../../assets/img/line_shoots/bound/black dress (2).jpg";
import BOUND_POST_32 from "../../assets/img/line_shoots/bound/black dress (3).jpg";
import BOUND_POST_41 from "../../assets/img/line_shoots/bound/black top (2).jpg";
import BOUND_POST_42 from "../../assets/img/line_shoots/bound/black top (3).jpg";

import INVASION_POST_11 from "../../assets/img/line_shoots/invasion/white and red (1).jpg";
import INVASION_POST_21 from "../../assets/img/line_shoots/invasion/yellow (1).jpg";
import INVASION_POST_31 from "../../assets/img/line_shoots/invasion/white and red (2).jpg";
import INVASION_POST_32 from "../../assets/img/line_shoots/invasion/white and red (3).jpg";
import INVASION_POST_41 from "../../assets/img/line_shoots/invasion/yellow (2).jpg";
import INVASION_POST_42 from "../../assets/img/line_shoots/invasion/yellow (3).jpg";

import SOMATIC_POST_11 from "../../assets/img/line_shoots/somatic/heart (1).jpg";
import SOMATIC_POST_21 from "../../assets/img/line_shoots/somatic/IMG_2258.jpg";
import SOMATIC_POST_31 from "../../assets/img/line_shoots/somatic/heart (2).jpg";
import SOMATIC_POST_32 from "../../assets/img/line_shoots/somatic/heart (3).jpg";
import SOMATIC_POST_41 from "../../assets/img/line_shoots/somatic/IMG_3197.jpg";

import RELINQUO_POST_11 from "../../assets/img/line_shoots/relinquo/concrete blocks (1).jpg";
import RELINQUO_POST_12 from "../../assets/img/line_shoots/relinquo/concrete blocks (2).jpg";
import RELINQUO_POST_21 from "../../assets/img/line_shoots/relinquo/IMG_2722.jpg";
import RELINQUO_POST_22 from "../../assets/img/line_shoots/relinquo/IMG_2728.jpg";
import RELINQUO_POST_31 from "../../assets/img/line_shoots/relinquo/concrete blocks (3).png";
import RELINQUO_POST_32 from "../../assets/img/line_shoots/relinquo/concrete blocks (4).jpg";
import RELINQUO_POST_41 from "../../assets/img/line_shoots/relinquo/PNTX6621.jpg";
import RELINQUO_POST_42 from "../../assets/img/line_shoots/relinquo/PNTX6634.jpg";

import DIGITAL_WARFARE_POST_11 from "../../assets/img/line_shoots/digital_warfare/corset (2).jpg";
import DIGITAL_WARFARE_POST_12 from "../../assets/img/line_shoots/digital_warfare/corset (3).jpg";
import DIGITAL_WARFARE_POST_21 from "../../assets/img/line_shoots/digital_warfare/IMG_3393.jpg";
import DIGITAL_WARFARE_POST_22 from "../../assets/img/line_shoots/digital_warfare/PNTX6882.jpg";
import DIGITAL_WARFARE_POST_31 from "../../assets/img/line_shoots/digital_warfare/corset (6).jpg";
import DIGITAL_WARFARE_POST_32 from "../../assets/img/line_shoots/digital_warfare/corset (8).jpg";
import DIGITAL_WARFARE_POST_41 from "../../assets/img/line_shoots/digital_warfare/white jacket.png";
import DIGITAL_WARFARE_POST_42 from "../../assets/img/line_shoots/digital_warfare/PNTX6887.jpg";

import ICARUS_POST_11 from "../../assets/img/line_shoots/icarus/blue and pink (1).jpg";
import ICARUS_POST_21 from "../../assets/img/line_shoots/icarus/yellow and blue (1).jpg";
import ICARUS_POST_31 from "../../assets/img/line_shoots/icarus/blue and pink (1).png";
import ICARUS_POST_32 from "../../assets/img/line_shoots/icarus/blue and pink (2).jpg";
import ICARUS_POST_41 from "../../assets/img/line_shoots/icarus/yellow and blue (2).jpg";
import ICARUS_POST_42 from "../../assets/img/line_shoots/icarus/yellow and blue (3).jpg";

import ALUMNI_POST_11 from "../../assets/img/line_shoots/alumni/black ripple dress (1).jpg";
import ALUMNI_POST_12 from "../../assets/img/line_shoots/alumni/black ripple dress (2).jpg";
import ALUMNI_POST_21 from "../../assets/img/line_shoots/alumni/white dress (1).jpg";
import ALUMNI_POST_22 from "../../assets/img/line_shoots/alumni/white dress (3).jpg";
import ALUMNI_POST_31 from "../../assets/img/line_shoots/alumni/PNTX6992.jpg";
import ALUMNI_POST_32 from "../../assets/img/line_shoots/alumni/PNTX7000.jpg";
import ALUMNI_POST_41 from "../../assets/img/line_shoots/alumni/white dress (4).jpg";
import ALUMNI_POST_42 from "../../assets/img/line_shoots/alumni/white dress (5).jpg";

/**
 * @brief Start times (in seconds) for each line's segment within the full
 * show video. Index matches LINE_INFO. Used by the line page's YouTube player
 * to fast-forward straight to the line on load. See issue #78.
 *
 * TODO: Fill in the real timestamps by watching the show video. The default
 * of 0 means "play from the beginning".
 */
export const LINE_SHOW_VIDEO_START_SECONDS = [
  0, // 01 Gossamer Idle
  0, // 02 Nexus
  0, // 03 Chrysophyta
  0, // 04 Mirror
  0, // 05 The Marianas Trench
  0, // 06 Obfuscate
  0, // 07 Salvos
  0, // 08 Bloom
  0, // 09 Renasci
  0, // 10 Bound
  0, // 11 Invasion
  0, // 12 Somatic
  0, // 13 Relinquo
  0, // 14 Digital Warfare
  0, // 15 Icarus
  0, // 16 Alumni
];

/**
 * @brief Line names in order, with their respective designers.
 * @type {LineInfo[]}
 */
export const LINE_INFO = [
  {
    name: 'Gossamer Idle',
    designers: [
      'Elise Chapman',
      'Jessica Lai'
    ],
    video_ready: 'https://streamable.com/9z91c9',
    description: 'Gossamer Idle is a combination between the grandeur of the Renaissance and modern day elegance. This idea stems from our luna moth motif — representing the renewal of body and spirit regeneration and ties in to our intent to create a new version of an old trend. With flowy and translucent material paired with harsher metals and leather, we create a sense of duality between femininity and masculinity in each look. Instead of following the distinct binary roles from old Europe, we believe that fashion is not a performance but performative, and we can use fashion to undermine gender stereotypes.',
    img_1: GOSSAMERIDLE_1,
    img_2: GOSSAMERIDLE_2,
    post_show_img: [
      [
        GOSSAMERIDLE_POST_11,
        GOSSAMERIDLE_POST_12,
      ],
      [
        GOSSAMERIDLE_POST_21,
        GOSSAMERIDLE_POST_22,
      ],
      [
        GOSSAMERIDLE_POST_31,
        GOSSAMERIDLE_POST_32,
      ],
      [
        GOSSAMERIDLE_POST_41,
        GOSSAMERIDLE_POST_42,
      ]
    ]
  },
  {
    name: 'Nexus',
    designers: [
      'Annalisa Pao'
    ],
    video_ready: 'https://streamable.com/9furjq',
    description :'Regardless of gender identity, hardness and softness coexist in each of us through masculine and feminine energy. The looks in Nexus embrace the varying balances of hardness and softness in people but also work to challenge the constructed ideas of traditional masculinity and femininity.',
    img_1: NEXUS_1,
    img_2: NEXUS_2,
    post_show_img: [
      [
        NEXUS_POST_21,
      ],
      [
        NEXUS_POST_11,
        NEXUS_POST_12,
      ],
      [
        NEXUS_POST_31,
        NEXUS_POST_32,
      ],
      [
        NEXUS_POST_41,
        NEXUS_POST_42,
      ]
    ]
  },
  {
    name: 'Chrysophyta',
    designers: [
      'Iz Horgan'
    ],
    video_ready: 'https://streamable.com/vn4mnz',
    description: 'Chrysophyta (kris-aw-fi-ta) is a golden colored algae found mostly in freshwater environments. With this reference in mind, the line merges classic dress silhouettes with the generative quality of this natural form. Layers of gathered and pleated chiffon are utilized in each garment to add movement, line and color.',
    img_1: CHRYSOPHYTA_1,
    img_2: CHRYSOPHYTA_2,
    post_show_img: [
      [
        CHRYSOPHYTA_POST_11,
      ],
      [
        CHRYSOPHYTA_POST_21,
      ]
    ]
  },
  {
    name: 'Mirror',
    designers: [
      'Khushi Nandgaonkar',
      'Kathy Zhang'
    ],
    video_ready: 'https://streamable.com/zaclht',
    description: 'Mirror depicts Pittsburgh’s various textured spaces through eight patchworked looks. Each look presents a different area of the city through either a landscape or an overhead view. There is often a disconnect between CMU students and the rest of the Pittsburgh community. Many undergrads leave Pittsburgh after four years having only seen a handful of its ninety neighborhoods. Pittsburgh is filled with much history and culture. It is a city teeming with talent and passionate community leaders. We hope that by depicting Pittsburgh through patchwork, we can inspire a deeper love and appreciation for the city within the CMU community.',
    img_1: MIRROR_1,
    img_2: MIRROR_2,
    post_show_img: [
      [
        MIRROR_POST_11,
      ],
      [
        MIRROR_POST_21,
      ]
    ]
  },
  {
    name: 'The Marianas Trench',
    designers: [
      'Lily Oberman',
      'Skylar McAuliffe'
    ],
    video_ready: 'https://streamable.com/zq5rhe',
    description: 'As humans, we pursue the unknown. The Marianas Trench is the deepest oceanic trench on Earth, perpetually dark and near freezing. It is a site completely distinct from human life, yet it continues to draw people down to extreme depths solely for the purpose of exploring the unexplored. Those who venture there bring back proof of the biodiversity, color, and beauty that thrives in the extreme pressure and temperature at these depths. Our line is a testament to the power of curiosity and exploration, through which we can bring light and warmth to the furthest mysteries of the universe.',
    img_1: MARIANASTRENCH_1,
    img_2: MARIANASTRENCH_2,
    post_show_img: [
      [
        MARIANAS_TRENCH_POST_21,
        MARIANAS_TRENCH_POST_11
      ],
      [
        MARIANAS_TRENCH_POST_41
      ],
    ]
  },
  {
    name: 'Obfuscate',
    designers: [
      'Arushi Bandi',
      'Maya Pandagurun'
    ],
    video_ready: 'https://streamable.com/79rktz',
    description: 'Surveillance has become ubiquitous in our daily life. We are watched whenever we leave our homes, wherever we go. Some activists and artists have even begun to wear “anti-surveillance” masks, accessories and make-up. We take this one step further and imagine a world where everyone takes precautions against the omnipresent eye of the camera through fashion. We explore how wealth will play a factor in who is seen and who goes by unnoticed. We include bright colors and dizzying patterns suited to confuse the camera and obfuscate people.This line is a humorous and chilling take on our further narrowing circle of privacy.',
    img_1: OBFUSCATE_1,
    img_2: OBFUSCATE_2,
    post_show_img: [
      [
        OBFUSCATE_POST_11
      ],
      [
        OBFUSCATE_POST_21
      ],
      [
        OBFUSCATE_POST_31
      ],
      [
        OBFUSCATE_POST_41
      ],
    ]
  },
  {
    name: 'Salvos',
    designers: [
      'Patricia Yu'
    ],
    video_ready: 'https://streamable.com/fjsba8',
    description: 'Many events that happened since 2019 has shown us how people have reacted differently towards a common situation. Although we share an experience, our actions are disorganized and chaotic. Whether that is an advantage or a catastrophe, we have seen a range of means for survival due to everyone’s unique environment and worldviews. I wanted to embody this where each outfit reflects the methods and values of “survival” that people have taken.',
    img_1: SALVOS_1,
    img_2: SALVOS_2,
    post_show_img: [
      [
        SALVOS_POST_11
      ],
      [
        SALVOS_POST_21
      ],
      [
        SALVOS_POST_31
      ],
      [
        SALVOS_POST_41
      ],
    ]
  },
  {
    name: 'Bloom',
    designers: [
      'Natalie Waldram',
      'Amal Jafrani'
    ],
    video_ready: 'https://streamable.com/rxr4gk',
    description: 'Bloom inspired by the uninhibited expression of childhood. Childhood can be characterized as a moment of intense curiosity as well as a vivid exploration of personal and cultural identity, which can soften as we age due to stricter adherence to social norms, standards, and occasions. Bloom aims to recreate the imaginative identities that emerge from a child’s extravagant, fantasy world by creating aesthetic abstractions of fictional childhood obsessions. This line combines a child’s disregard for time and place with a fascination for fantasy to create “occasion-less”, fantasy-inspired pieces.',
    img_1: BLOOM_1,
    img_2: BLOOM_2,
    post_show_img: [
      [
        BLOOM_POST_11
      ],
      [
        BLOOM_POST_21
      ],
      [
        BLOOM_POST_31
      ],
      [
        BLOOM_POST_41
      ],
    ]
  },
  {
    name: 'Renasci',
    designers: [
      'Aadya Bhartia',
    ],
    video_ready: 'https://streamable.com/hgs89l',
    description: 'Renasci explores the interaction between growth and rebirth. Adaptability and evolution work in unison as we traverse through various phases of our existence. The grounds of this evolution is determined by the environment we thrive in. Through Renasci, I aim to draw a parallel between the malleability of wire and the influence of the people who surround us. The delicate fabric contrasts against the rigid wire, creating a dialect between the two and imbibes an instance of rebirth.',
    img_1: RENSACI_1,
    img_2: RENSACI_2,
    post_show_img: [
      [
        RENASCI_POST_11,
        RENASCI_POST_12,
      ],
      [
        RENASCI_POST_21,
      ],
      [
        RENASCI_POST_31,
        RENASCI_POST_32,
      ],
      [
        RENASCI_POST_41,
      ],
    ]
  },
  {
    name: 'Bound',
    designers: [
      'Owen Haft',
      'Carmen Yu',
    ],
    video_ready: 'https://streamable.com/bnk0lt',
    description: 'Bound juxtaposes the preconceptions of chains and metal with the lightness and transparency of a veil. Metal and chains are assumed as rigid and restrictive. We seek to counter that view by demonstrating an exaggerated form of and around the human body by keeping a sense of lightness to the garments, through the use of handmade metal chains, metallic wire, and black fabrics that accentuate some, while covering other parts of the human form. We aim to create beautifully embellished garments that evoke and challenge the seriousness that comes with metal chains.',
    img_1: BOUND_1,
    img_2: BOUND_2,
    post_show_img: [
      [
        BOUND_POST_11,
      ],
      [
        BOUND_POST_21,
      ],
      [
        BOUND_POST_31,
        BOUND_POST_32,
      ],
      [
        BOUND_POST_41,
        BOUND_POST_42,
      ],
    ]
  },
  {
    name: 'Invasion',
    designers: [
      'Olivia Luk',
    ],
    video_ready: 'https://streamable.com/6gtby0',
    description: 'Lately there have been a lot of changes my life that I feel are outside of my control and when I try to resist these changes it feels like I’m trying to stop the inevitable. Inspired by how the human body and natural world reflect this sense of invasive growth, I took images of things people often try to, but can’t control about the human body like acne, body hair, and bodily fluids, and tried to relate them to images of unwanted plants and species in nature like mold, sea slugs, algae, ivy and fungi.',
    img_1: INVASION_1,
    img_2: INVASION_2,
    post_show_img: [
      [
        INVASION_POST_11,
      ],
      [
        INVASION_POST_21,
      ],
      [
        INVASION_POST_31,
        INVASION_POST_32,
      ],
      [
        INVASION_POST_41,
        INVASION_POST_42,
      ],
    ]
  },
  {
    name: 'Somatic',
    designers: [
      'Jessa Westheimer'
    ],
    video_ready: 'https://streamable.com/ssifa5',
    description: 'Somatic considers the relationship we have with our bodies, especially with what is beneath our skin. It is important to reflect on the way we are designed as well as the structures, systems, and forms  which sustain us. We are not at all the Vitruvian Man or an illustration in an anatomy textbook or a Photoshopped photo in a magazine. We are imperfect and beautiful, and somehow, all the parts of our bodies keep us moving and living.',
    img_1: null,
    img_2: null,
    post_show_img: [
      [
        SOMATIC_POST_11,
      ],
      [
        SOMATIC_POST_21,
      ],
      [
        SOMATIC_POST_31,
        SOMATIC_POST_32,
      ],
      [
        SOMATIC_POST_41,
      ],
    ]
  },
  {
    name: 'Relinquo',
    designers: [
      'Kwins Yang',
      'Jacky Tian'
    ],
    video_ready: 'https://streamable.com/6oyxs4',
    description: 'The migration of the human race is undertaken by a series of obligatory adaptation, monotonous meandering, and warped reawakening. NORI: all energy resources are powered by water. NOMEN: the end of pigmentation. NOIR: storage and transportation of memories become achievable. NOMAD: functionalism and utilitarianism are main ideologies. NORRIN: a group of interstellar hipsters rises. NOAH: new myths and tales were created based on life on earth. NO.1379: a protest against the human race invading other civilizations. NOTO: women warriors become leaders of the human race.',
    img_1: RELINQUO_1,
    img_2: RELINQUO_2,
    post_show_img: [
      [
        RELINQUO_POST_11,
        RELINQUO_POST_12,
      ],
      [
        RELINQUO_POST_21,
        RELINQUO_POST_22,
      ],
      [
        RELINQUO_POST_31,
        RELINQUO_POST_32,
      ],
      [
        RELINQUO_POST_41,
        RELINQUO_POST_42,
      ]
    ]
  },
  {
    name: 'Digital Warfare',
    designers: [
      'Cassie Scheirer',
      'Madi Davis'
    ],
    video_ready: 'https://streamable.com/4l78dp',
    description: 'Before 2020, we dreamed of an immersive, virtual future, of automata and instancy and the superhuman, but none of it was necessary. Today, as a result of the pandemic, we have finally gotten a taste of a virtual future — and it has notes of danger. Virtuality dictates our working, learning, socializing, and entertainment, harming our minds, bodies, and goals, and Digital Warfare is a call to revolt. We illustrate eight bright, dauntless, and forceful leaders in the movement, each representing a negative impact of technology, who seek a return and adherence to traditional reality.',
    img_1: DIGITALWARFARE_1,
    img_2: DIGITALWARFARE_2,
    post_show_img: [
      [
        DIGITAL_WARFARE_POST_11,
        DIGITAL_WARFARE_POST_12,
      ],
      [
        DIGITAL_WARFARE_POST_21,
        DIGITAL_WARFARE_POST_22,
      ],
      [
        DIGITAL_WARFARE_POST_31,
        DIGITAL_WARFARE_POST_32,
      ],
      [
        DIGITAL_WARFARE_POST_41,
        DIGITAL_WARFARE_POST_42,
      ]
    ]
  },
  {
    name: 'Icarus',
    designers: [
      'Vincent Derienzo',
      'Leah Kendrick',
      'Tyng Peck'
    ],
    video_ready: 'https://streamable.com/op8qo6',
    description: 'ICARUS creates a vision of post-apocalyptic, human architectures while exploring the evolution of solar shading and environmental protection systems. As global heating consumes landmasses and sediment pollutes airways, the call to shelter in place within one’s own personal space becomes real. While alarms blare in today’s hazmat suit, the future of skin and protection allows us to filter ultraviolet and pollution while living a lifestyle of the occasion. Through exploring and recreating iconic forms that emblemize and transcend class and gender, we created a world where beauty is isolation, mechanics, and self-obsession.',
    img_1: ICARUS_1,
    img_2: ICARUS_2,
    post_show_img: [
      [
        ICARUS_POST_11,
      ],
      [
        ICARUS_POST_21,
      ],
      [
        ICARUS_POST_31,
        ICARUS_POST_32,
      ],
      [
        ICARUS_POST_41,
        ICARUS_POST_42,
      ],
    ]
  },
  {
    name: 'Alumni',
    designers: [
      'Terrence Boyd',
      'Grace Kao',
    ],
    video_ready: 'https://streamable.com/3z2z9z',
    description: 'Two talented alumni have returned to design the Alumni Line, a celebration of CMU graduates who we’ve stayed connected to. Our first alumna is Grace Kao, whose line will be androgynous and soft, pulled together by the color white, which will represent a blank slate and hopeful new beginning for 2021. Next, Terry Boyd will infuse the 90’s in his line of male streetwear, incorporating pieces from the Spice Girls, his first musical love. He will work in black and white, embroidery, and gold leaf. We are glad to have them back in the community and designing for Lunar Gala.',
    img_1: null,
    img_2: null,
    post_show_img: [
      [
        ALUMNI_POST_11,
        ALUMNI_POST_12,
      ],
      [
        ALUMNI_POST_21,
        ALUMNI_POST_22,
      ],
      [
        ALUMNI_POST_31,
        ALUMNI_POST_32,
      ],
      [
        ALUMNI_POST_41,
        ALUMNI_POST_42,
      ]
    ]
  }
];


export const LINE_NAME_LOOKUP = LINE_INFO.map(
  entry => entry.name
);